import React, { useCallback, useState } from 'react';
import ReactDOM from 'react-dom';
import { useEditorContext } from '../../Editor/Context';
import {
  useVisualViewport,
  VisualViewport,
} from '@wix/da-ds/pkg/hooks/useVisualViewport';
import cn from 'classnames';
import { usePortalNode } from '@wix/da-ds/pkg/popper/hooks/usePortalNode';
import UniversalMobileMenu from '../UniversalMobileMenu';

import s from './FixedMobileMenu.scss';

export interface Props {
  className?: string;
  noAtomics?: boolean;
}

/**
 * Fixed menu at the top of the screen. Meant to be used with mobile when we don't have a dedicated area to slot
 * the toolbar into.
 */
const FixedMobileMenu = React.forwardRef<HTMLDivElement, Props>(
  ({ className, noAtomics }, ref) => {
    const portalNode = usePortalNode('editor-toolbar');
    const editor = useEditorContext();

    const [visualViewport, setVisualViewport] = useState<
      VisualViewport | undefined
    >();
    const viewportHandler = useCallback((v: VisualViewport) => {
      setVisualViewport(v);
    }, []);
    useVisualViewport(viewportHandler, true);

    if (!editor) {
      return null;
    }

    // TODO limit this to the top of editor.view.dom
    const style: React.CSSProperties = {
      top: visualViewport?.offsetTop ?? 0,
      width: visualViewport?.width,
      overflow: 'hidden',
    };

    // We have to use portal to avoid z-index overrides from editor parent elements.
    return (
      portalNode &&
      ReactDOM.createPortal(
        <div ref={ref} className={cn(s['root'], className)} style={style}>
          <UniversalMobileMenu noAtomics={noAtomics} omitHRule />
        </div>,
        portalNode
      )
    );
  }
);
FixedMobileMenu.displayName = 'FixedMobileMenu';

export default FixedMobileMenu;
